var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPopupColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 21,
    height: 21,
    rx: 2.5,
    fill: "#F3F3F3",
    stroke: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.35,
    y: 3.85,
    width: 8.52533,
    height: 14.9151,
    rx: 0.65,
    fill: "white",
    stroke: "#FFB600",
    strokeWidth: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.35,
    y: 3.85,
    width: 8.52533,
    height: 8.57536,
    rx: 0.65,
    fill: "#FFB600",
    fillOpacity: 0.5,
    stroke: "#FFB600",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 4.50391L13.9266 5.43029",
    stroke: "#FFB600",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0181 5.39844L13.9128 4.5037",
    stroke: "#FFB600",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPopupColumn);
export default __webpack_public_path__ + "static/media/ic-popup-column.cf7cfb714f8a60b78a128e7bf4d17bdf.svg";
export { ForwardRef as ReactComponent };